export default __webpack_public_path__ + "src/assets/downloads/2024_Mine_Emergency_Management_Plan.pdf";